// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeliveredProcedureOutlinedSvg from "@ant-design/icons-svg/es/asn/DeliveredProcedureOutlined";
import AntdIcon from '../components/AntdIcon';

var DeliveredProcedureOutlined = function DeliveredProcedureOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeliveredProcedureOutlinedSvg
  }));
};

DeliveredProcedureOutlined.displayName = 'DeliveredProcedureOutlined';
export default React.forwardRef(DeliveredProcedureOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DeliveredProcedureOutlined.js
// module id = 927
// module chunks = 0